module.exports = __webpack_public_path__ + "media/barometer/meta-image-f8fbd93c.png";